import React from "react";
import classes from "./bulkSpareDetailHead.module.css";
import { dateFormatter } from "../../../../utils/dateFormatter";
import { StatusBadge } from "./BulkSpareDetailForm";
import { ChatPanel } from "../../../chatPanel/ChatPanel";

export const BulkSpareDetailHead = ({
  lot_name,
  uploaded_on,
  approval_status,
}) => {
  return (
    <div className={classes.box__section}>
      
      {/* LEFT */}
      <div className={classes.left}>
        <h1 className={classes.title}>{lot_name}</h1>
        <span className={classes.date}>
          Uploaded on {dateFormatter(uploaded_on)}
        </span>
        <StatusBadge status={approval_status} />
      </div>

      {/* RIGHT */}
      <div className={classes.right}>
        
        <ChatPanel />
      </div>

    </div>
  );
};